<template >
  <b-modal
    id="locationdetails"
    size="lg"
    body-class="bg-white"
    hide-footer
    title="Locations"
    ref="locationdetails"
  >
    <div class="customer_view_tab no-flex-grow" pills small v-if="singleitemrow.locationdetails">
      <div style="max-width:900px !important;">
        <b-button-group size="sm" class="mb-3">
          <b-button
            :pressed="stock_account == 'acc_stock_details'"
            :variant="stock_account == 'acc_stock_details' ? 'primary' : 'light'"
            @click="stock_account = 'acc_stock_details'"
          >Account Stock</b-button>
          <b-button
            :pressed="stock_account == 'phy_stock_details'"
            :variant="stock_account == 'phy_stock_details' ? 'primary' : 'light'"
            @click="stock_account = 'phy_stock_details'"
          >Physical Stock</b-button>
        </b-button-group>
        <br />
        <table class="table table-bordered reports-table-border">
          <thead>
            <th class="text-left">Location Name</th>
            <th class="text-right">Stock on Hand</th>
            <th class="text-right">Committed Stock</th>
            <th class="text-right">Available for Sale</th>
          </thead>
          <tbody>
            <tr v-for="item in singleitemrow.locationdetails" :key="item.id">
              <td class="text-left">
                <b-form-radio
                  :disabled="singleitemrow.inv_itm_id && singleitemrow.sal_itm_id || $route.name == 'PackageCreate'|| $route.name == 'PackageUpdate'"
                  v-model="singleitemrow.warehouse_id"
                  name="some-radios"
                  :value="item.warehouse_id"
                >{{ item.warehouse_name }}</b-form-radio>
              </td>
              <td
                class="text-right"
              >{{ Number(item[stock_account].good_on_hand).toLocaleString(undefined, { minimumFractionDigits: 0,maximumFractionDigits:0 }) }}</td>
              <td
                class="text-right"
              >{{ Number(item[stock_account].commited_stock).toLocaleString(undefined, { minimumFractionDigits: 0,maximumFractionDigits:0 }) }}</td>
              <td
                class="text-right"
              >{{ Number(item[stock_account].available_for_sale).toLocaleString(undefined, { minimumFractionDigits: 0,maximumFractionDigits:0 }) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ["singleitemrow"],
  data() {
    return {
      stock_account: "acc_stock_details"
    };
  }
};
</script>

<style>
</style>
